import React from 'react';
import Slider from "react-slick";
import image1 from '../Assets/imgs/FortisHeader1.png';
import image2 from '../Assets/imgs/FortisHeader2.png';
import image3 from '../Assets/imgs/FortisHeader3.png';
import image4 from '../Assets/imgs/FortisHeader4.png';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Ccontainer = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
return (
  <div className="slider-wrapper recom-body">
    <div>
      <Slider {...settings}>
        <div>
          <img  
            className="d-block w-100"
            src={image1}
            alt="Fortis"
            style={{maxHeight:'640px',maxWidth:'800px'}}
          />
        </div>
        <div>
          <img
            className="d-block w-100"
            src={image2}
            alt="MegaHoot Messenger"
            style={{maxHeight:'640px',maxWidth:'800px'}}
          />
        </div>
        <div>
        <img
            className="d-block w-100"
            src={image3}
            alt="VeroHive"
            style={{maxHeight:'640px',maxWidth:'800px'}}
          />
        </div>
        <div>
        <img
            className="d-block w-100"
            src={image4}
            alt="Vero Town Hall"
            style={{maxHeight:'640px',maxWidth:'800px'}}
          />
        </div>
      </Slider>
    </div>
  </div>
  )
}

export default Ccontainer;